import React, { Fragment, useState, useEffect, useContext } from 'react'
import useApi from 'hooks/useApi'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { useKeyboardShortcut } from '@arnsbogroup/react-voicearchive/lib/hooks'
import TaskFiles from './../TaskFiles'
import Stats from './../Stats'
import { selectUnit } from '@formatjs/intl-utils'
import NiceModal from '@ebay/nice-modal-react'
import BulkCreateVersionsModal from './../BulkCreateVersionsModal'
import { Button, Chip, InputInline } from '@arnsbogroup/react-voicearchive'
import { Menu, Transition } from '@headlessui/react'
import DeleteTaskMenuItem from '../DeleteTaskMenuItem'

const JobPage = ({ job, order, refetch, readOnly }) => {
  const { formatMessage, formatRelativeTime } = useIntl()
  const [jobFiles, jobFilesLoading,, loadJobFiles] = useApi(`/rest/v1/task/${job?.uid}/files`)
  const [files, setFiles] = useState([])
  const [loading, setLoading] = useState(false)
  const { value, unit } = selectUnit(+job.crdate * 1000)

  useEffect(() => setFiles(jobFiles), [jobFiles])

  const stats = [
    { title: 'Versions', primary: job.versions.length, secondary: null, stat: null, changeType: '+' },
    { title: 'Tasks', primary: job.versions.map(({ tasks }) => tasks.length).reduce((x, n) => x + n, 0), secondary: null, stat: null, changeType: '+' },
    { title: 'Created', primary: formatRelativeTime(value, unit), secondary: null, stat: null, changeType: '+' },
    { title: 'Job files', primary: files?.length || 0, secondary: null, stat: null, changeType: '+' },
  ]

  const onChange = (body) => {
    setLoading(true)
    fetch(`/rest/v2/task/${job.uid}`, { method: 'PUT', body: JSON.stringify(body) })
      .then((response) => response.json())
      .then(({ success, data, errors }) => {
        if (!success) {
          window?.toastr.error(Object.values(errors).join(', '))
        }
      })
      .then(() => setLoading(false))
      .then(refetch)
      .catch((error) => window.alert(error))
  }

  return (
    <div>
      <div className="p-4 flex items-center justify-between border-b border-gray-200">
        <div className="space-y-2">
          <Chip>Job</Chip>
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
            { loading ? (
              <span>Loading..</span>
            ) : (
              <InputInline 
                disabled={readOnly || loading}
                className="w-full"
                value={job.title || 'Untitled'}
                onChange={({ target: { value } }) => {
                  onChange({ title: value })
                }}
              />
            ) }
          </h2>
        </div>

        <div className="mt-5 flex lg:mt-0 lg:ml-4 shrink-0">
          <Button
            size="sm"
            disabled={readOnly || loading}
            onClick={() => NiceModal.show(BulkCreateVersionsModal, { order, job } ).then(refetch)}
          >
            + Version
          </Button>
          <Menu as="div" className="relative ml-3">
            <Menu.Button>
              <Button variant="outline" size="sm" icon={['fal', 'ellipsis-vertical']} iconPosition="right">
                More
              </Button>
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 z-50 mt-2 -mr-1 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <DeleteTaskMenuItem taskType="Job" readOnly={readOnly || loading} task={job} order={order} refetch={refetch} />
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>

      <Stats stats={stats} />

      <TaskFiles
        fetchFiles={loadJobFiles}
        loading={jobFilesLoading}
        files={files}
        setFiles={setFiles}
        task={job}
      />
    </div>
  )
}

export default JobPage
